<template>
<div class="footer-wrapper">
<div>
    <div class="container--response">
    <div class="footer-bottom">
      <ul class="footer-link clearfix" id="dav">
        <li>
          <a @click="go('/about')" target="_blank" rel="nofollow" style="cursor:pointer;">关于我们</a>
        </li>
        <li>
          <a @click="go('/contact')"  target="_blank" rel="nofollow" style="cursor:pointer;">联系我们</a>
        </li>
        <li>
          <a @click="go('/falv')"  target="_blank" rel="nofollow" style="cursor:pointer;">法律声明</a>
        </li>
        <li>
          <a @click="go('/zishen')"  target="_blank" rel="nofollow" style="cursor:pointer;">自审制度</a>
        </li>
        <li>
          <a @click="go('/yhxy')"  target="_blank" rel="nofollow" style="cursor:pointer;">用户协议</a>
        </li>
        <li>
          <a @click="go('/yinsi')"  target="_blank" rel="nofollow" style="cursor:pointer;">隐私政策</a>
        </li>
        <li>
          <a @click="go('/wcn')"  target="_blank" rel="nofollow" style="cursor:pointer;">未成年家长监护工程体系</a>
        </li>
      </ul>
      <div style="margin-top:10px;">
        <ul class="footer-link clearfix" id="dav1">
          <li>
            <a href="https://jbts.mct.gov.cn/" target="_blank" rel="nofollow">12318全国文化市场举报</a>
          </li>
          <li>
            <a href="https://www.12377.cn/" target="_blank" rel="nofollow">网上有害信息举报</a>
          </li>
          <li>
            <a href="http://www.shdf.gov.cn/shdf/channels/740.html" target="_blank" rel="nofollow">扫黄打非举报</a>
          </li>
          <li>
            <a href="https://www.12377.cn/jbxzxq/zpljbxzxq.html?spm=zm1033-001.0.0.1.SOXBdI" target="_blank" rel="nofollow">电信诈骗举报</a>
          </li>
          <li>
            <a href="https://www.12377.cn/jbxzxq/64d38691937611ebb858c9da04cf59d3_web.html?spm=zm1033-001.0.0.1.SOXBdI&amp;smallHarmType=64d38691937611ebb858c9da04cf59d3" target="_blank" rel="nofollow">历史虚无主义举报</a>
          </li>
        </ul>
      </div>
      <p>
        <span>联系电话：010-82861984</span>
        <!-- <span>联系QQ：<a href="tencent://message/?uin=1044420059&amp;Site=www.mkzhan.com&amp;Menu=yes" target="_blank" rel="nofollow">1044420059</a></span> -->
        <span>举报邮箱：<a href="litchi_chen@easou.cn">litchi_chen@easou.cn</a></span>
        <span>工作时间：周一至周五9：00--18：00</span>
        联系地址：北京市海淀区学清路10号院学清嘉创大厦C座706室
      </p>
      <p>
        <span>&nbsp;&nbsp;&nbsp;&nbsp;<a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" rel="nofollow">京ICP备19002340号-1</a></span>
        <span>&nbsp;&nbsp;&nbsp;&nbsp;<a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802029868" target="view_window"><img src="../../../assets/beian_police.png" style="width:15px;vertical-align:-3px;margin-right:2px;">京公安备案号：11010802029868号</a></span>
        <span>&nbsp;&nbsp;&nbsp;&nbsp;<a @click="showPermit()">京网文 (2022)3847-113 号</a></span>
      </p>
      <p>
        <span>Copyright ©2011-2025<a href="https://easoubj.com/#" rel="nofollow">宜搜动漫</a></span>
        <span><a href="https://easoubj.com/#/" target="_blank" rel="nofollow">北京宜搜天下科技有限公司</a></span>
        版权所有
        <!-- <a href="https://easoubj.com/#/" rel="nofollow" target="_blank"> -->
        <!-- <img class="pic-copyright" src="//static.mkzcdn.com/home/assets/images/footer/footer_copyright.png?v=2f3e4cb"> -->
        <!-- </a> -->
      </p>
      <div class="maskDialog" v-show="showPermitValue" @click.self="closePermit()">
        <div class="img" :style="{width:width, height: height,marginLeft:marginLeft,marginTop:marginTop}">
          <img src="../../../assets/permit.png" />
        </div>
        <div class="close" @click="closePermit()" :style="{marginLeft:marginLeft0,marginTop:marginTop0}">X</div>
      </div>
    </div>
  </div>
</div>
</div>

</template>
<script>
export default {
    data(){
      return{
        showPermitValue:false,
        width:"591px",
        height:"842px",
        marginLeft:"-297px",
        marginTop:"-421px",
        marginLeft0:"320px",
        marginTop0:"-421px"
      }
    },
    mounted(){
      console.log("初始化。。。。。。。。。");
      var height1=window.innerHeight*0.9;
      var width1=height1*(591/842);
      var marginLeft1=-1*(width1/2);
      var marginTop1=-1*(height1/2);
      this.height=height1+"px";
      this.width=width1+"px";
      this.marginLeft=marginLeft1+"px";
      this.marginTop=marginTop1+"px";
      this.marginLeft0=((width1/2)+30)+"px";
      this.marginTop0=-1*(height1/2)+"px";
    },
    methods:{
      go (path) {
        this.$router.push(path);
      },
      showPermit(){
        //console.log("展现");
        this.showPermitValue=true;
      },
      closePermit(){
        this.showPermitValue=false;
      }
    }
}
</script>
<style>
div{
    padding: 0;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    display: block;
    font: 12px/1.33333 'PingFang SC', 'Lantinghei SC', 'Microsoft Yahei', 'Hiragino Sans GB', 'Microsoft Sans Serif', 'WenQuanYi Micro Hei', sans-serif;
}
.footer-wrapper {
    text-align: center;
    padding: 16px 0 28px;
    margin: 0 auto;
    background: #434343;
    color: #fff;
}
.container--response{
    bottom:0;
    height: 200px;
    position: relative;
    min-height: 44px;
    /*width: 1500px !important;*/
    margin: 0 auto;
}
.footer-bottom {
    text-align: center;
    padding: 16px 0 28px;
    margin: 0;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    color: #fff;
    font: 12px/1.33333 'PingFang SC', 'Lantinghei SC', 'Microsoft Yahei', 'Hiragino Sans GB', 'Microsoft Sans Serif', 'WenQuanYi Micro Hei', sans-serif;
}
.footer-wrapper .footer-link {
    display: inline-block;
    /* font-size: 0; */
    margin: 0;
    padding: 0;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    text-align: center;
}
.clearfix:after {
    content: ".";
    display: block;
    height: 0;
    clear: both;
    visibility: hidden;
}
.footer-wrapper a {
    color: #fff;
}
.footer-wrapper .footer-link {
    display: inline-block;
    /* font-size: 0; */
}
#dav li{
    float: left;
    margin-left:20px;
    list-style:none
}
#dav1 li{
    float: left;
    margin-left:20px;
    list-style:none
}
.maskDialog{
  position: fixed;
  left:0;
  right:0;
  top:0;
  bottom:0;
  background: rgba(0,0,0,0.3);
  z-index: 1000;
}
.maskDialog .img{
  position: absolute;
  width: 595px;
  height: 842px;
  left:50%;
  top:50%;
  margin-left:-297px;
  margin-top:-421px;
}
.maskDialog .img img{
  height:100%;
}
.maskDialog .close{
  position: absolute;
  width: 40px;
  height: 40px;
  font-weight: bolder;
  background: #f7f7f7;
  color: #666666;
  left: 50%;
  top: 50%;
  margin-top: -421px;
  margin-left: 320px;
  font-size: 23px;
  border-radius: 20px;
  line-height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/view/base/footer/footer.vue